(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a1-home-colors"] && !Shopify.designMode) return;
  try {
    
  if (!window.a1HomeColorControlsReady) {
    window.a1HomeColorControlsReady = true;
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-a1-color-shift]');
      if (!button) return;
      const track = button.closest('.a1-home-colors')?.querySelector('.a1-home-colors__track');
      if (!track) return;
      const card = track.querySelector('.a1-home-colors__card');
      const distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .7;
      track.scrollBy({ left: distance * Number(button.dataset.a1ColorShift), behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a1-home-motifs"] && !Shopify.designMode) return;
  try {
    
  if (!window.a1HomeMotifControlsReady) {
    window.a1HomeMotifControlsReady = true;
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-a1-motif-shift]');
      if (!button) return;
      const track = button.closest('.a1-home-motifs')?.querySelector('.a1-home-motifs__track');
      if (!track) return;
      const card = track.querySelector('.a1-home-motifs__card');
      const distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .7;
      track.scrollBy({ left: distance * Number(button.dataset.a1MotifShift), behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
